import { endpoints } from 'Constants';

const businessServices = {
	createBusiness: (params) => ({
		baseURL: endpoints.BUSINESS.CREATE_BUSINESS(params),
		method: 'POST',
		data: params.payload,
	}),
	getCategories: (params) => ({
		baseURL: endpoints.BUSINESS.CATEGORIES(params),
		method: 'GET',
	}),
	getBusiness: (params) => ({
		baseURL: endpoints.BUSINESS.GET_BUSINESS(params),
		method: 'GET',
		params: params?.query,
	}),
	getBusinessList: (params) => ({
		baseURL: endpoints.BUSINESS.GET_BUSINESS_list(params),
		method: 'GET',
		params: params?.query,
	}),
	getRateAndReview: (params) => ({
		baseURL: endpoints.BUSINESS.RATEANDREVIEW(params),
		method: 'GET',
		params: params?.param,
	}),
	getBusinessItem: (params) => ({
		baseURL: endpoints.BUSINESS.GET_BUSINESS(params),
		method: 'GET',
	}),
	updateBusinessCommision: (params) => ({
		baseURL: endpoints.BUSINESS.UPDATE_COMMISION(params.businessId),
		method: 'POST',
		data: params.payload,
	}),
	updateBusiness: (params) => ({
		baseURL: endpoints.BUSINESS.GET_BUSINESS({ businessId: params.businessId }),
		method: 'PUT',
		data: params.data,
	}),
	summaryBusiness: (params) => ({
		baseURL: endpoints.BUSINESS.MARKETING_REPORT(
			params.date,
			params.businessId
		),
		method: 'GET',
	}),

	contractLink: (params) => ({
		baseURL: endpoints.BUSINESS.CONTRACT_LINK(params.businessId),
		method: 'POST',
		data: params.data,
	}),

	contractSign: (params) => ({
		baseURL: endpoints.BUSINESS.CONTRACT_SIGN(),
		method: 'POST',
		data: params.data,
	}),

	businessPackges: (params) => ({
		baseURL: endpoints.BUSINESS.PACKAGES(params?.businessId, params?.filters),
		method: 'GET',
	}),

	getSuperBusiness: (params) => ({
		baseURL: endpoints.BUSINESS.SUPER_USER(params),
		method: 'GET',
	}),

	getContractBusinessInfo: (params) => ({
		baseURL: endpoints.BUSINESS.CONTRACT_BUSINESS_INFO(params),
		method: 'GET',
	}),

	getCashierMachines: (params) => ({
		baseURL: endpoints.BUSINESS.CASHIER_MACHINES(params),
		method: 'GET',
	}),
};

export default businessServices;
